import styled from 'styled-components/native'
import { WarningIcon } from 'native-base'
import colors from '@instaseat/lib/themes/colors'

export const NotifyIcon = styled(WarningIcon)`
  color: ${colors.tertiary};
  width: 16px;
  height: 16px;
`
